import React from "react";
import { Outlet, Navigate } from "react-router-dom";

function PrivateRoute({ render: Render, ...rest }) {
  if (!rest.authToken) return <Navigate to="/auth/login" />;
  return <Outlet {...rest} />;
}

export default PrivateRoute;
